<div class="contacto-faq">
    <h2 class="section-tit1">¿TE QUEDAN DUDAS?</h2>
    <p class="text-bold">Haznos tu pregunta y te responderemos...</p>
    <p>
        <a class="lnk-primary" href="mailto:{{email}}" title="" target="_blank">{{email}}</a>
    </p>
    <neo-formulario-contacto-front [class]="'form-lg'"></neo-formulario-contacto-front>
</div>